export default "__VITE_ASSET__$zNtGGdZ__"